<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content badge-content" v-loading.lock="loading">
        <div class="go-back" @click="goBack">返回</div>
        <div class="badge-tips">
          <div class="badge-title">
            展商胸卡（截止日期：2024年10月30日，之后填写的将无法制作）
          </div>
          <div class="badge-infor">
            <div class="badge-div">
              <p>·展会实行参展商胸卡实名制</p>
              <p>
                ·根据展馆相关规定，所有进入展览场馆的人员需实名登记身份信息，因此请您填写准确的个人身份信息
              </p>
              <p>
                ·参展商可免费申请胸卡，数量为4张/9平米（此处为9平米倍数，每增加9平米则数量增加4张，总面积不足9平米按9平米计算）
              </p>
              <br />
              <p>胸卡信息提交后，为在列表中显示，请刷新页面。</p>
              <br />
              <p class="red">重要提示：</p>
              <p class="red">
                1、往届胸卡信息需重新确认，请逐个勾选需要设置为本届参展商或VIP的信息，并点击列表下方的“批量设定参展商”或“批量设定VIP”，同一人员无需重复设置参展商和VIP
              </p>
              <p class="red">
                2、当本届参展商/VIP状态栏内，显示为“<i
                  style="font-size: 20px; color: #52c41a; font-weight: bold"
                  class="el-icon-check"
                ></i
                >”时，即为设置成功
              </p>
            </div>
            <!-- <div class="badge-code">
              <div style="margin-right: 25px">
                <el-image :src="codeUrl" class="code-url"></el-image>
                <p class="red" style="text-align: center; font-size: 12px">
                  请勿随意发送此申请码
                </p>
              </div>
              <div class="red">
                <p>
                  请将左侧二维码发送给您公司参加展会的人员，扫描二维码进行展商证件申领。请注意：
                </p>
                <p>1、到场参展人员都需用自己手机进行实名认证，他人无法代办；</p>
                <p>
                  2、请根据贵司可申请胸卡数量发送注册码给相应人员。超出人员将无法获得展商胸卡，请进行<a
                    href="https://reg.reed-sinopharm.com/pc/#/login?id=6d9b75cc7ca545b795b9485ea82e1706&channelUuid=0eff9272dc0a4f828ff806e194cebe3e"
                    target="_blank"
                    >参观登记</a
                  >
                </p>
                <p>
                  3、管理员可通过下方列表查看参展人员申报情况，并可根据需要调整获得展商胸卡的人员；
                </p>
              </div>
            </div> -->
          </div>
        </div>
        <div class="badge-title">
          <div>
            展商胸卡列表（{{ badgeCount }}/{{ badge_num }}）；VIP（{{
              vipCount
            }}/{{ vip_num }}）
          </div>
          <div style="display:flex;">
            <div v-if="isShowBtn" class="create-wrap">
              <el-upload
                v-if="isShowImportBtn"
                :action="$fileUrlImportBadge"
                :headers="headers"
                :data="{
                  mark: mark,
                }"
                :multiple="false"
                :on-success="handleFileSuccess"
                :on-error="handleFileError"
                :show-file-list="false"
              >
                <div class="badge-create badge-bg">上传导入模板</div>
              </el-upload>
              <a
                v-if="isShowImportBtn"
                class="badge-create badge-bg"
                href="/uploads/badge/参展商胸卡申请导入示例表.xls"
                download="参展商胸卡申请导入示例表.xls"
                >下载批量导入模板</a
              >
              <div class="badge-create" @click="edit('')">创建展商胸卡</div>
            </div>
            <!-- 24.10.22 新增开通扫一扫功能 dxm -->
            <div class="badge-create" @click="scanHandle">开通扫一扫</div>
          </div>
        </div>
        <div class="badge-search">
          <div class="search-item">
            <p>本届参展商</p>
            <el-select
              v-model="search.is_exhibitor"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="search-item">
            <p>本届vip</p>
            <el-select v-model="search.is_vip" clearable placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="search-item">
            <p>姓名</p>
            <el-input v-model="search.nickname" placeholder="请填写"></el-input>
          </div>
          <div class="search-item">
            <p>手机</p>
            <el-input v-model="search.tel" placeholder="请填写"></el-input>
          </div>
          <div class="search-item search-btn-wrap">
            <div class="search-btn" @click="searchHandle">搜索</div>
          </div>
        </div>
        <!-- 胸卡列表 -->
        <div class="badge-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column label="ID" prop="id" width="70"></el-table-column>
            <el-table-column :label="'本届\n参展商'" width="70">
              <template slot-scope="scope">
                <div class="icon-wrap">
                  <!-- @click="setBadgeHandle('is_exhibitor', 1, scope.row)" 24.10.30 隐藏本届参展商操作功能 dxm -->
                  <i
                    v-if="scope.row.is_exhibitor == 0"
                    class="el-icon-close"
                  ></i>
                  <!-- @click="setBadgeHandle('is_exhibitor', 0, scope.row)" 24.10.30 隐藏本届参展商操作功能 dxm -->
                  <i
                    v-if="scope.row.is_exhibitor == 1"
                    class="el-icon-check"
                  ></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="'本届\nVIP'" width="50">
              <template slot-scope="scope">
                <div class="icon-wrap">
                  <!-- @click="setBadgeHandle('is_vip', 1, scope.row)" 24.10.30 隐藏本届VIP操作功能 dxm -->
                  <i v-if="scope.row.is_vip == 0" class="el-icon-close"></i>
                  <!-- @click="setBadgeHandle('is_vip', 0, scope.row)" 24.10.30 隐藏本届VIP操作功能 dxm -->
                  <i v-if="scope.row.is_vip == 1" class="el-icon-check"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="姓名"
              prop="nickname"
              min-width="70"
            ></el-table-column>
            <el-table-column
              label="身份证号码"
              prop="id_number"
              min-width="170"
            ></el-table-column>
            <el-table-column
              label="部门"
              prop="department"
              min-width="80"
            ></el-table-column>
            <el-table-column
              label="职位"
              prop="position"
              min-width="90"
            ></el-table-column>
            <el-table-column
              label="子公司"
              prop="child_company"
              min-width="80"
            ></el-table-column>
            <el-table-column
              label="手机"
              prop="tel"
              min-width="110"
            ></el-table-column>
            <el-table-column
              label="电子邮箱"
              prop="email"
              min-width="80"
            ></el-table-column>
            <el-table-column
              label="添加时间"
              prop="inputtime"
              min-width="110"
            ></el-table-column>
            <el-table-column label="操作" width="100" fixed="right">
              <template slot-scope="scope">
                <span class="check-btn" @click="edit(scope.row)">查看</span>
                <!-- 24.10.30 隐藏删除功能 dxm -->
                <!--| <span class="check-btn check-del" @click="del(scope.row)"
                  >删除</span
                > -->
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination_box">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page.sync="search.page_no"
              :page-size="search.page_size"
              layout="total, prev, pager, next"
              :total="totals"
            >
            </el-pagination>
          </div>
        </div>
        <div class="pagination_btn_wrap" v-if="isShowBtn">
          <div
            class="pagination_btn"
            @click="badgeMoreHandle('is_exhibitor', 1)"
          >
            批量设定本届参展商
          </div>
          <div
            class="pagination_btn"
            @click="badgeMoreHandle('is_exhibitor', 0)"
          >
            批量取消本届参展商
          </div>
          <div class="pagination_btn" @click="badgeMoreHandle('is_vip', 1)">
            批量设定本届vip
          </div>
          <div class="pagination_btn" @click="badgeMoreHandle('is_vip', 0)">
            批量取消本届vip
          </div>
        </div>
      </div>
      <!-- 胸卡详情 -->
      <el-dialog
        :title="badgeId ? '编辑展商胸卡' : '添加展商胸卡'"
        :visible.sync="drawerEditMask"
        width="40%"
        :close-on-click-modal="false"
      >
        <div class="badge-details">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            label-position="right"
            class="demo-ruleForm"
          >
            <el-form-item label="姓名" prop="nickname">
              <el-input v-model="ruleForm.nickname"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="id_number">
              <el-input v-model="ruleForm.id_number"></el-input>
            </el-form-item>
            <el-form-item label="部门" prop="department">
              <el-input v-model="ruleForm.department"></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="position">
              <el-input v-model="ruleForm.position"></el-input>
            </el-form-item>
            <el-form-item label="子公司" prop="child_company">
              <el-input v-model="ruleForm.child_company"></el-input>
            </el-form-item>
            <el-form-item label="手机" prop="tel">
              <el-input v-model="ruleForm.tel"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input v-model="ruleForm.email"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="drawerEditMask = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  badgeList,
  delBadge,
  editBadge,
  badgeDetail,
  addBadge,
  updBoolean,
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "exbadgeList",
  data() {
    return {
      loading: false,
      active: 3,
      tableData: [],
      totals: 0,
      codeUrl: require("../assets/xcx_code.png"),
      search: {
        is_exhibitor: "", //是否本届展商
        is_vip: "", //是否本届vip
        nickname: "",
        tel: "",
        page_no: 1,
        page_size: 10,
      },
      options: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      badgeCount: "", // 已填写胸卡数
      badge_num: "", // 胸卡名额数
      vipCount: "", //  已填写VIP数
      vip_num: "", //  VIP名额数
      drawerEditMask: false,
      badgeId: "",
      ruleForm: {
        nickname: "",
        id_number: "",
        department: "",
        position: "",
        child_company: "",
        tel: "",
        email: "",
      },
      rules: {
        nickname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        id_number: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
          {
            pattern:
              /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/,
            message: "请输入正确的身份证号码",
            trigger: "blur",
          },
        ],
        department: [
          { required: true, message: "请输入部门", trigger: "blur" },
        ],
        position: [{ required: true, message: "请输入职位", trigger: "blur" }],
        tel: [
          { required: true, message: "请输入手机", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请输入电子邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
      multipleSelection: [],
      isShowBtn: false,
      isShowImportBtn: false,
      headers: {},
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "conference" && item.id == 11;
    });
    this.active = index;
    let token = localStorage.getItem("token");
    this.headers = {
      token: token,
    };
    this.mark = this.$route.query.mark;
    this.getBadgeList();
  },
  created() {},
  methods: {
    //24.10.22 跳转到扫一扫 dxm
    scanHandle() {
      this.$router.push({
        path: "/scan",
      });
    },
    // 返回
    goBack() {
      this.$router.back();
    },
    //搜索
    searchHandle() {
      this.getBadgeList();
    },
    //获取展商胸卡列表
    getBadgeList() {
      this.loading = true;
      let data = this.$qs.stringify(this.search);
      badgeList(data)
        .then((res) => {
          //console.log(res, "=<======res");
          if (res.data.code == 1) {
            let { data } = res.data;
            this.badgeCount = data.badgeCount;
            this.badge_num = data.badge_num;
            this.vipCount = data.vipCount;
            this.vip_num = data.vip_num;
            this.totals = data.count;
            this.tableData = data.lists;
            this.isShowBtn = data.badge_btn_display == 1 ? true : false;
            this.isShowImportBtn = data.import_btn_display == 1 ? true : false;
            this.loading = false;
            if (this.badgeCount == 0 && this.vipCount == 0) {
              this.$alert("您还未设置本届参展商，请勾选参展人员进行批量设置");
            }
          }
        })
        .catch((err) => {});
    },
    //多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 编辑
    edit(row) {
      this.drawerEditMask = true;
      if (row) {
        this.badgeId = row.badge_long_id;
        this.getBadgeDetail(row.badge_long_id);
      } else {
        this.badgeId = "";
        this.ruleForm.badge_long_id = "";
        this.ruleForm.nickname = "";
        this.ruleForm.id_number = "";
        this.ruleForm.department = "";
        this.ruleForm.position = "";
        this.ruleForm.child_company = "";
        this.ruleForm.tel = "";
        this.ruleForm.email = "";
      }
    },
    //胸卡详情
    getBadgeDetail(id) {
      let data = this.$qs.stringify({
        badge_long_id: id,
      });
      badgeDetail(data)
        .then((res) => {
          //console.log(res, "=<======res");
          if (res.data.code == 1) {
            let { data } = res.data;
            this.ruleForm.badge_long_id = data.badge_long_id;
            this.ruleForm.nickname = data.nickname;
            this.ruleForm.id_number = data.id_number;
            this.ruleForm.department = data.department;
            this.ruleForm.position = data.position;
            this.ruleForm.child_company = data.child_company;
            this.ruleForm.tel = data.tel;
            this.ruleForm.email = data.email;
          }
        })
        .catch((err) => {});
    }, // 删除
    del(row) {
      this.$alert(`确定要删除吗？`, "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            delBadge({ badge_long_id: row.badge_long_id })
              .then((res) => {
                if (res.data.code == 1) {
                  this.$message.success(res.data.msg);
                  this.search.page_no = 1;
                  this.getBadgeList();
                }
              })
              .catch((err) => {
                console.log(err, "===err");
              });
          }
        },
      });
    },
    // 分页相关
    handleCurrentChange(val) {
      this.search.page_no = val;
      this.getBadgeList();
    },
    //胸卡详情保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.badge_long_id) {
            this.saveEditBadge();
          } else {
            this.saveAddBadge();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //编辑胸卡详情
    saveEditBadge() {
      let data = this.ruleForm;
      data.mark = this.mark;
      editBadge(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.search.page_no = 1;
            this.getBadgeList();
            this.drawerEditMask = false;
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //添加胸卡
    saveAddBadge() {
      let data = this.ruleForm;
      data.mark = this.mark;
      addBadge(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.search.page_no = 1;
            this.getBadgeList();
            this.drawerEditMask = false;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //批量设置胸卡
    badgeMoreHandle(type, val) {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("您未选中任何项！");
        return false;
      }
      let select = this.multipleSelection
        .filter((item) => item.badge_long_id)
        .map(({ badge_long_id }) => badge_long_id);
      select = select.join(",");
      console.log(select);
      updBoolean({
        field: type,
        val,
        ids: select,
        mark: this.mark,
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.getBadgeList();
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch((err) => {});
    },
    //列表单个设置本届参展商／本届vip
    setBadgeHandle(type, val, row) {
      console.log(type, val, row);
      updBoolean({
        field: type,
        val,
        ids: row.badge_long_id,
        mark: this.mark,
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.getBadgeList();
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch((err) => {});
    },
    //文件上传成功
    handleFileSuccess(resData, file, fileList) {
      if (resData.code == 1) {
        this.$alert(resData.data.msg, "", {
          confirmButtonText: "确定",
          callback: (action) => {
            if (action == "confirm") {
            }
          },
        });
        this.getBadgeList();
      } else {
        this.$alert(resData.data.msg, "", {
          confirmButtonText: "确定",
          callback: (action) => {
            if (action == "confirm") {
            }
          },
        });
      }
    },
    //文件上传失败
    handleFileError(err, file, fileList) {
      this.$alert(err.message, "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
          }
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table th > .cell {
  white-space: pre-wrap;
}
.badge-content {
  margin-bottom: 0;
  .badge-title {
    font-weight: 500;
    font-size: 16px;
    color: #354052;
    line-height: 24px;
    padding: 0 0 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .create-wrap {
      display: flex;
    }
    .badge-create {
      min-width: 103px;
      height: 36px;
      color: #fff;
      font-size: 14px;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
      border-radius: 4px;
      margin-left: 10px;
      padding: 0 10px;
      box-sizing: border-box;
      background: linear-gradient(270deg, #fe4d34 0%, #fc933f 100%);
    }
    .badge-bg {
      background: #fc933f;
    }
  }
  .badge-infor {
    display: flex;
    // align-items: center;
    flex-wrap: wrap;
    .badge-div {
      // width: 52%;
      width: 100%;
      padding-right: 20px;
      box-sizing: border-box;
    }
    .badge-code {
      width: 48%;
      min-height: 230px;
      padding: 40px 25px 35px 25px;
      display: flex;
      font-size: 14px;
      line-height: 25px;
      box-sizing: border-box;
      background: #f7f8fb;
      border-radius: 18px;
      a {
        color: #3d83e9;
        text-decoration: underline;
      }
      .code-url {
        width: 140px;
        height: 140px;
        border-radius: 50%;
      }
    }
  }
  .badge-tips {
    font-size: 14px;
    color: #1d1d1d;
    line-height: 22px;
    padding: 20px;
    background: #fff;
    border-radius: 10px;
    margin: 20px 0;
    .red {
      color: #ff4d4f;
    }
  }
  .badge-search {
    display: flex;
    flex-wrap: wrap;
    align-items: end;
    background: #fff;
    padding: 20px;
    border-radius: 10px;
    .search-item {
      width: 20%;
      font-size: 14px;
      color: #7f8fa4;
      line-height: 22px;
      margin-right: 24px;
      margin-bottom: 10px;
      p {
        margin-bottom: 7px;
      }
      .el-select {
        width: 100%;
      }
      .search-btn {
        width: 103px;
        height: 40px;
        color: #fff;
        font-size: 14px;
        line-height: 40px;
        text-align: center;
        background: #fc933f;
        border-radius: 3px;
        cursor: pointer;
      }
    }
    .search-btn-wrap {
      width: 103px;
      margin-right: 0;
    }
  }
  .badge-table {
    padding: 20px 0;
    .el-table {
      border-radius: 10px;
      /deep/ .el-table__body-wrapper {
        min-height: 300px;
      }
    }
    .icon-wrap {
      font-size: 20px;
      .el-icon-close {
        color: #eb4141;
        font-weight: bold;
      }
      .el-icon-check {
        color: #52c41a;
        font-weight: bold;
      }
    }
    .check-btn {
      color: #3d83e9;
      cursor: pointer;
      font-weight: 500;
    }
    .check-btn:hover {
      text-decoration: underline;
    }
    .check-del {
      color: #ff4d4f;
    }
    .pagination_box {
      display: flex;
      align-items: center;
      justify-content: right;
      margin-top: 50px;
    }
  }
  .pagination_btn_wrap {
    display: flex;
    flex-wrap: wrap;
    position: fixed;
    bottom: 20px;
    z-index: 99;
    .pagination_btn {
      color: #fff;
      height: 32px;
      font-size: 14px;
      cursor: pointer;
      line-height: 32px;
      padding: 0 12px;
      border-radius: 4px;
      background: #3d83e9;
      margin-top: 10px;
      margin-right: 10px;
    }
  }
}
.badge-details {
  padding: 0 30px;
  .details-title {
    font-size: 16px;
    font-weight: 500;
    color: #3d83e9;
    padding-bottom: 20px;
    border-bottom: 1px solid #3d83e9;
  }
  .demo-ruleForm {
    padding: 10px 70px 10px 0;
  }
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fff;
}
/deep/ .el-table td,
/deep/ .el-table th.is-leaf {
  border-bottom: 0 none;
}
/* 表格最外层边框-底部边框 */
/deep/ .el-table--border::after,
/deep/ .el-table--group::after {
  width: 0;
}
/deep/ :focus {
  outline: 0;
}
/deep/ .el-drawer__header {
  font-size: 18px;
  color: #333;
  font-weight: 500;
}
@media only screen and (max-width: 1339px) {
  .badge-content .badge-search .search-item {
    width: 21%;
  }
  .badge-content .badge-search .search-btn-wrap {
    width: calc(84% + 72px);
    display: flex;
    justify-content: end;
  }
}
@media only screen and (max-width: 1060px) {
  .badge-content .badge-search .search-item {
    width: 45%;
  }
  .badge-content .badge-search .search-btn-wrap {
    width: calc(90% + 24px);
    display: flex;
    justify-content: end;
  }
  .badge-content .badge-infor {
    flex-wrap: wrap;
    .badge-div,
    .badge-code {
      width: 100%;
    }
    .badge-code {
      margin-top: 20px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .content {
    margin: 0;
    padding: 20px;
  }
  .badge-content .badge-search .search-item {
    width: 100%;
    margin-right: 0;
  }
  .badge-content .badge-table .pagination_box .pagination_left {
    flex-wrap: wrap;
  }
  .badge-content .badge-table .pagination_box .pagination_left .pagination_btn {
    margin-bottom: 10px;
  }
  .pagination_box {
    flex-wrap: wrap;
    .el-pagination {
      width: 100%;
      padding: 20px 0;
      text-align: right;
    }
  }
  /deep/ .el-dialog {
    width: 90% !important;
  }
  .badge-details {
    padding: 0;
    .demo-ruleForm {
      padding: 0;
    }
  }
}
</style>